import LocationView from './LocationView';
import './LocationView.scss';

export default LocationView;
